// extracted by mini-css-extract-plugin
module.exports = {"container":"entities_card_footer-module__container--zUBGW"};